/**
 * Shared table styles for all V2 trade tables.
 *
 * Base styles consumed by: PortfolioTradeV2, SwitchSection, SwitchPlansTrade,
 * SavingsPlansTrade, PayoutPlansTrade.
 */

// region BASE TABLE STYLES

export const baseTableCellStyles = {
  fontFamily: 'Roboto-Regular',
  fontSize: 14,
  color: '#202A38',
  '&.expand-cell': {
    width: 50,
  },
  '&.name-cell': {
    maxWidth: 450,
    '@media (max-width: 600px)': {
      maxWidth: 170,
    },
  },
  '&.sustainability-cell': {
    minWidth: 83,
    width: 83,
  },
  '&.discount-cell': {
    width: 100,
  },
  '&.delete-cell': {
    width: 50,
  },
  '&.bg-white': {
    background: '#fff',
  },
  '&.amount-cell': {
    width: 175,
  },
  '&.einzeltitel-settings-cell': {
    width: 155,
    paddingLeft: 16,
  },
  '&.sell-all-cell': {
    width: 100
  },
};

export const baseInputCellStyles = {
  '& .MuiInput-root': {
    height: 30,
    fontSize: 14,
  },
};

// NOTE: uses $tableCell reference — the consuming makeStyles must define `tableCell` in the same stylesheet.
export const baseTableFooterStyles = {
  background: '#EEF0F2',

  '& $tableCell': {
    fontFamily: 'Roboto-Bold',
    verticalAlign: 'middle',
  },
};

export const baseTableRowStyles = {
  '& $tableCell:not(.with-input)': {
    paddingTop: 13,
  },
  '& $tableCell.with-input': {
    ...baseInputCellStyles,
  }
};

// region SWITCH TABLE STYLES

export const switchPositionCellStyles = {
  width: 35,
  maxWidth: 35,
};

export const switchAmountCellStyles = {
  width: 200,
  maxWidth: 200,
  ...baseInputCellStyles,
};

export const switchPercentageCellStyles = {
  width: 80,
  ...baseInputCellStyles,
};

export const switchQuantityCellStyles = {
  width: 140,
  maxWidth: 140,
  ...baseInputCellStyles,
};

export const switchHighlightedRowStyles = {
  '&.highlighted:not(:first-child)': {
    borderTop: '4px solid #D9DCDF',
  },
};

// endregion

// region LAYOUT STYLES

export const tableContainerStyles = {
  overflowX: 'auto',
};

// endregion
